import styled from "styled-components";
import { Image as AntImage } from "antd";
import { DefaultIMG } from '@assets';

export const Loader = styled.div`
width: 100%;
height: calc(100vh - 150px);
display: flex;
align-items: center;
justify-content: center;
`;

export const RootContainer = styled.div`
  overflow: hidden;
`;

export const Container = styled.div`
`;

export const Top = styled.div`
padding: 16px 0;
display: flex;
gap: 8px;
flex-direction: column;
align-items: center;
justify-content: center;
border-radius: 0px 0px 16px 16px;
background: linear-gradient(90deg, #2D0059 0%, #4D0395 100%);
position: relative;

svg {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;

export const Image = styled(AntImage).attrs({
  alt: "gameicon",
  fallback: DefaultIMG,
  preview: false,
})`
  width: 70px !important;
  height: 70px !important;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: 12px;
`;

export const Title = styled.div`
  text-align: center;
  color: #fff;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const PlayerListContainer = styled.div`
  width: 100%;
  height: calc(100vh - 256px);
  margin: 0;
  overflow: auto;
`;

export const PlayerBox = styled.div`
  background: #F8EEFF;
  padding: 16px;
  display: flex;
  flex-direction: row;
  gap: 12px;
  border-top: 1px solid #fff;
`;

export const Number = styled.p`
min-width: 20px;
  text-align: right;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #5D5189;
`;

export const DataContainer = styled.div`
  flex-grow: 1;
  gap: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const NameAndAmountContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`

export const PlayerName = styled.p`
  flex-grow: 1;
  color: #5D5189;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

export const Amount = styled.p`
  color: #49028E;
  text-align: right;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

export const PhoneNumberContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`

export const PhoneNumber = styled.p`
  flex-grow: 1;
  color:  #9B92BB;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`
